<template>
  <div
    class="auth-multiple-input"
    :class="inputCls">
    <AuthFormAutoComplete
      v-if="['autoComplete'].includes(type)"
      type="autoComplete"
      ref="input"
      v-bind="$attrs"
      v-on="$listeners"
      @validator="validator"
    ></AuthFormAutoComplete>
    <AuthFormInputText
      v-if="['text'].includes(type)"
      type="text"
      ref="input"
      v-bind="$attrs"
      v-on="$listeners"
      @validator="validator"
    ></AuthFormInputText>
    <AuthFormInputText
      v-if="['password'].includes(type)"
      type="password"
      ref="input"
      v-bind="$attrs"
      v-on="$listeners"
      @validator="validator"
    ></AuthFormInputText>
    <AuthFormInputPassword
      v-if="['password-plus'].includes(type)"
      type="password-plus"
      ref="input"
      v-bind="$attrs"
      v-on="$listeners"
      @validator="validator"
    ></AuthFormInputPassword>
    <AuthFormUpload
      v-if="['upload'].includes(type)"
      type="upload"
      ref="input"
      v-bind="$attrs"
      v-on="$listeners"
      @validator="validator"
    ></AuthFormUpload>
    <AuthFormSmsCaptcha
      v-if="['smsCaptcha'].includes(type)"
      type="smsCaptcha"
      ref="input"
      v-bind="$attrs"
      v-on="$listeners"
      @validator="validator"
    ></AuthFormSmsCaptcha>
    <AuthFormImageCaptcha
      v-if="['imageCaptcha'].includes(type)"
      type="imageCaptcha"
      ref="input"
      v-bind="$attrs"
      v-on="$listeners"
      @validator="validator"
    ></AuthFormImageCaptcha>
    <div class="message">
      {{ message }}
    </div>
  </div>
</template>

<script>
import AuthFormAutoComplete from './auth-form-auto-complete.vue';
import AuthFormInputText from './auth-form-input-text.vue';
import AuthFormInputPassword from './auth-form-input-password.vue';
import AuthFormUpload from './auth-form-upload.vue';
import AuthFormSmsCaptcha from './auth-form-sms-captcha.vue';
import AuthFormImageCaptcha from './auth-form-image-captcha.vue';
export default {
  name: 'AuthMultipleInput',
  components: {AuthFormAutoComplete, AuthFormInputText, AuthFormInputPassword, AuthFormUpload, AuthFormSmsCaptcha, AuthFormImageCaptcha},
  props: {
    type: {
      type: String,
      default: 'text',
    },
    styleType: {
      type: String,
      default: 'style-1',
    },
  },
  data() {
    return {
      status: true,
      message: '',
    };
  },
  computed: {
    styleCls() {
      return this.styleType;
    },
    errorCls() {
      return this.status ? '' : 'error';
    },
    inputCls() {
      return [this.styleCls, this.errorCls].join(' ');
    },
  },
  methods: {
    validator(val) {
      if (val === true) {
        this.status = val;
        this.message = '';
      } else {
        this.status = false;
        this.message = val;
      }
    },
    isValid() {
      return this.$refs['input'].check();
    },
    getOriginValue() {
      return this.$refs['input'].data;
    },
  },
};
</script>

<style lang="scss">
.auth-multiple-input {
  margin-bottom: 20px;
  border-bottom: 1px solid rgba(0,0,0,.1);
  transition: border-color 200ms;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  .message {
    position: absolute;
    top: 36px;
    left: 1px;
    font-size: 12px;
    color: #fd5959;
    display: none;
  }
  &.error {
    border-color: #fd5959;
    .message {
      display: block;
    }
  }
  &.style-1 {
    .input {
      flex: 1;
      display: flex;
      position: relative;
      input {
        flex: 1;
        outline: 0;
        border: 0;
        width: 100%;
        display: block;
        height: 32px;
        font-size: 14px;
        background: white;
        border-radius: 4px;
        box-sizing: border-box;
        transition: all ease-in 200ms;
        color: rgba($color: #000000, $alpha: 0.85);
        padding: 0;
        &::-webkit-input-placeholder {
          color: rgba($color: #000000, $alpha: 0.45);
        }
        &:focus {
          outline: 0;
          box-shadow: none;
        }
      }
    }

    .image-captcha {
      flex: 1;
      display: flex;
      position: relative;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      input {
        flex: 1;
        outline: 0;
        border: 0;
        width: 100%;
        display: block;
        height: 32px;
        font-size: 14px;
        background: white;
        border-radius: 4px;
        box-sizing: border-box;
        transition: all ease-in 200ms;
        color: rgba($color: #000000, $alpha: 0.85);
        &::-webkit-input-placeholder {
          color: rgba($color: #000000, $alpha: 0.45);
        }
      }
      img {
        height: 24px;
      }
    }
    .sms-captcha {
      flex: 1;
      display: flex;
      position: relative;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      input {
        flex: 1;
        outline: 0;
        border: 0;
        width: 100%;
        display: block;
        height: 32px;
        font-size: 14px;
        background: white;
        border-radius: 4px;
        box-sizing: border-box;
        transition: all ease-in 200ms;
        color: rgba($color: #000000, $alpha: 0.85);
        &::-webkit-input-placeholder {
          color: rgba($color: #000000, $alpha: 0.45);
        }
      }
      .btn {
        border: 1px solid #1890ff;
        border-radius: 4px;
        padding: 2px 4px;
        color: #1890ff;
        font-size: 12px;
        &.disabled {
          background: #eee;
          color: #999;
          border-color: #eee;
        }
      }
    }
  }
}
</style>
